/**
 * @author 友人a丶
 * @date
 * 注册Vue全局方法
 * */

import user from "@/stores/user";
import sys from "@/stores/system";

/**
 * 注册vue的全局方法
 * @param app {object}
 */
export default function (app) {

    /**
     * 挂载用户信息
     * @return {Store<"user", {GameStatus: string, routes: [], role: number, level: string, jifen: string, nickname: string, clan_id: string, longhun: string, SteamID: string, token: string}, {}, {setToken(*): void, save(*): void}>}
     */
    app.config.globalProperties.$user = () => {
        return user();
    };

    /**
     * 挂着全局配置
     * @return {Store<"loaded", {loaded: boolean, zhuce: string, filterRoutes: boolean, title: string, type1: string, url: string}, {}, {set(*): void, load(): void}>}
     */
    app.config.globalProperties.$sys = () => {
        return sys();
    };

}